module.exports = __webpack_public_path__ + "img/cb-l-ro1.352b036d.gif";